import { Component, Inject, Input, OnInit, Output,EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { ConfService } from 'src/app/conf.service';
import { LeftpanelComponent } from 'src/app/leftpanel/leftpanel.component';
import { DialogData } from 'src/app/partner-onboard/partner-onboard.component';

@Component({
  selector: 'app-billing-credits',
  templateUrl: './billing-credits.component.html',
  styleUrls: ['./billing-credits.component.scss']
})
export class BillingCreditsComponent implements OnInit {

  @Input() creditsData: any = [];
  @Output() redeemCreditEvent:any = new EventEmitter();

  constructor(public dialog: MatDialog) { }

  ngOnInit() {
  }

  getDateFrmt1(time) {
    const date = new Date(time);
    return date.toLocaleString();
  }

  redeemCredit() {
    const dialogRef = this.dialog.open(RedeemCreditDialog, {
      width: '60vw',
      height: 'auto'

    });

    dialogRef.afterClosed().subscribe(result => {

      if (result && result['message'] == 'success') {
        this.redeemCreditEvent.emit({ creditAdded: true });
      }

    });
  }

}


@Component({
  selector: 'redeem-credit-dialog',
  templateUrl: 'redeem-credit.html',
  styleUrls: ['redeem-credit.css']
})
export class RedeemCreditDialog {
  creditPromoCode: any
  captchaKey = '6LeiA80UAAAAAK-P15G3dY3V_KOkzTZrUG4NLAWj';
  captcha: any;
  loadingCredit = false;
  constructor(
    private confPost: ConfService, public platform: LeftpanelComponent,
    public dialogRef: MatDialogRef<RedeemCreditDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.confPost.getCaptchaSiteKey().subscribe(response => {
      if (response && response[0]) {
        this.captchaKey = response[0]['value'];
      }
    });
  }

  applyCredits() {
    if (this.creditPromoCode !== undefined && this.creditPromoCode !== '') {
      const payload = {
        'code': this.creditPromoCode,
        'partner': localStorage.getItem('partner'),
        'timestamp': Date.now()
      };
      this.loadingCredit = true;
      this.confPost.applyCredit(payload).subscribe(res => {
        this.loadingCredit = false;
        this.creditPromoCode = '';
        if (res['message'] === 'Credits added') {
          this.platform.openSnackBar(res['message'], 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
          this.dialogRef.close({ message: 'success' });
        } else {
          this.platform.openSnackBar(res['message'], 'Error', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      }, err => {
        this.platform.openSnackBar('Error while adding credits. Please try after sometime.', 'Error', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
        this.loadingCredit = false;
      });
    } else {
      this.platform.openSnackBar('Provide correct promotion code.', 'Error', {
        duration: 5000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

  resolved(captchaResponse: string) {
    this.captcha = captchaResponse;
  }

  close() {
    this.dialogRef.close();
  }
}
